import React from "react";
import Class from "../../components/screen-page/ilkb-workout/Class";
import SelectClass from "../../components/screen-page/ilkb-workout/SelectClass";

const ClassType = ({screen}) => {
  return (
    <>
    <SelectClass screen={screen} />
    </>
  )
}

export default ClassType;